export default "__VITE_ASSET__CAGPz$MM__"